import request from '../utils/request'
export function queryMedias (data) {
  return request({
    url: 'common/queryLockedMedias',
    method: 'POST',
    data
  })
}

/**
 * 同步更新楼盘数据
 * @param data
 */
export function syncMergeProject (data) {
  return request({
    url: 'common/syncMergeProjectData',
    method: 'POST',
    data
  })
}

/**
 *查询位置属性
 * @param data
 */
export function querySysMediaParam (data) {
  return request({
    url: 'sysMediaParam',
    method: 'GET',
    params: data
  })
}

/**
 *新增位置
 * @param data
 */
export function createSysMediaParam (data) {
  return request({
    url: 'sysMediaParam',
    method: 'POST',
    data
  })
}
/**
 *修改位置
 * @param data
 */
export function updateSysMediaParam (data) {
  return request({
    url: 'sysMediaParam',
    method: 'PUT',
    data
  })
}
/**
 *删除位置
 * @param data
 */
export function deleteSysMediaParam (data) {
  return request({
    url: 'sysMediaParam/' + data,
    method: 'DELETE'
  })
}
/**
 *查询保存的配置信息
 * @param data
 */
export function findConfigStorageByKey (data) {
  return request({
    url: 'configStorage/find',
    method: 'POST',
    data: data
  })
}
/**
 *更新或者新增配置信息
 * @param data
 */
export function updateOrSavePerson (data) {
  return request({
    url: 'configStorage/updateOrSavePerson',
    method: 'POST',
    data: data
  })
}

/**
 * 异步任务执行
 * @param data
 */
export function asyncTask () {
  return request({
    url: 'asyncExecuteTask/resetMediaCode',
    method: 'POST'
  })
}
export function loadChildRegion (data) {
  return request({
    url: 'common/loadChildRegion/' + data,
    method: 'GET'
  })
}
export function getFullRegionName (data) {
  return request({
    url: 'common/getFullRegionName/' + data,
    method: 'GET'
  })
}
export function getAllShareTenant (data) {
  return request({
    url: 'shareRelation/getAllShareTenant',
    method: 'GET',
    params: {
      tenantId: data
    }
  })
}

// 批量删除点位
export function batchDeleteByCode (data) {
  return request({
    url: 'allmedias/batchDeleteByCode',
    method: 'DELETE',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js